export enum SortingDirection {
    Ascending = "Ascending",
    Descending = "Descending",
    None = "None"
};